export type TEventParamsRecord = Record<string, string | number | undefined>

export type TEventParams = {
    params__key: string[]
    params__value: number[]
    params__str_value: string[]
}

/**
 * Spreads { key: value } into the three positionally aligned arrays session events expect. The
 * string -> str_value / number -> value split repeats `getEventParams` from @muse/analytics, or the
 * same axis lands in a different column than on UG, MU and SMP. The arrays must stay the same length:
 * the backend appends its own axes at the same positions.
 */
export const buildParams = (record: TEventParamsRecord): TEventParams => {
    const params: TEventParams = {
        params__key: [],
        params__value: [],
        params__str_value: [],
    }

    Object.keys(record).forEach(key => {
        const value = record[key]

        if (value === undefined || value === '') {
            return
        }

        params.params__key.push(key)

        if (typeof value === 'string') {
            params.params__str_value.push(value)
            params.params__value.push(0)

            return
        }

        params.params__str_value.push('')
        params.params__value.push(value)
    })

    return params
}
